import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { MdOutlineMeetingRoom, MdRectangle } from "react-icons/md";
import { FaBed, FaCircle, FaEdit, FaInfoCircle, FaRupeeSign } from "react-icons/fa";
import { BsDash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Model from "../Model";
import { TbRectangleVerticalFilled } from "react-icons/tb";
import { IoMdHelpCircleOutline } from "react-icons/io";
import NotFoundModel from "../NotFoundModel";
import { capitalizeFirstLetter, truncateText } from "../../helpers";

// Custom Tooltip Component
const CustomTooltip = ({ children, content, id, position = "bottom" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });

  const showTooltip = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setCoords({
      x: rect.left + rect.width / 2,
      y: position === "bottom" ? rect.bottom : rect.top
    });
    setIsVisible(true);
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
      >
        {children}
      </div>
      {isVisible && (
        <div
          id={id}
          // className="fixed z-50 bg-blue-50 text-black p-6 shadow-lg rounded-lg max-w-xs border border-blue-200"
          className="fixed z-50 bg-white text-gray-800
           px-4 py-3 text-sm
           shadow-xl rounded-lg
           border border-gray-200 max-w-xs"

          style={{
            left: coords.x,
            top: position === "bottom" ? coords.y + 5 : coords.y - 5,
            transform: position === "bottom"
              ? 'translateX(-50%)'
              : 'translate(-50%, -100%)'
          }}
        >
          <div className="absolute w-3 h-3 bg-blue-50 transform rotate-45 border-r border-b border-blue-200"
            style={{
              left: '50%',
              top: position === "bottom" ? '-6px' : 'auto',
              bottom: position === "bottom" ? 'auto' : '-6px',
              transform: position === "bottom"
                ? 'translateX(-50%) rotate(45deg)'
                : 'translateX(-50%) rotate(225deg)'
            }}
          />
          {content}
        </div>
      )}
    </div>
  );
};

const Table = ({
  apiData,
  setAddBed,
  setSelectedData,
  setAddTenant,
  setEditModel,
  isFlat,
  setFlatModel,
  setRoomNumberModel,
  propStatus,
  selectedFilter,
  selectedFloor,
  setIsExtraBed,
  setIsExtraBedDelete,
}) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [selectedBed, setSelectedBed] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [apiData]);

  const bed = (item) => {
    setAddBed(true);
    setSelectedData(item);
  };

  const deleteBed = (bed) => {
    setIsExtraBedDelete(true);
    setSelectedData(bed);
  };

  const editRoom = (item) => {
    setEditModel(true);
    setSelectedData(item);
  };

  const addRoomNumber = (item) => {
    setRoomNumberModel(true);
    setSelectedData(item);
  };

  const editFlat = (item) => {
    setFlatModel(true);
    setSelectedData(item);
  };

  const tenant = (bed, item) => {
    setAddTenant(true);
    setSelectedData({ bed, item });
  };

  const handleBedClick = (bed, item) => {
    if (bed.status === Config.BED_STATUS.MOVING_OUT) {
      setSelectedBed({ ...bed, item });
      setIsModalOpen(true);
    } else if (bed.status === Config.BED_STATUS.RESERVED) {
      setSelectedBed({ ...bed, item });
      setIsModalOpen(true);
    } else if (
      bed.status === Config.BED_STATUS.OCCUPIED ||
      bed.status === Config.BED_STATUS.VACANT_RESERVED
    ) {
      navigate(`/tenantdetails/b/${bed.id}`, {
        state: { tenantStatus: Config.TENANT_STATUS.OCCUPIED },
      });
    } else if (bed.status === Config.BED_STATUS.VACANT && propStatus == 3) {
      tenant(bed, item);
    }
  };

  const handleAddNewTenant = () => {
    setIsModalOpen(false);
    tenant(selectedBed, selectedBed.item);
  };

  const handleEvictedTenantDetail = () => {
    const tenantId = selectedBed?.occupancies?.[0]?.tenantId;
    navigate(`/tenantdetails/b/${selectedBed.id}/${tenantId}`, {
      state: { tenantStatus: Config.TENANT_STATUS.MOVING_OUT, e: 1, tenantId: tenantId },
    });
    setIsModalOpen(false);
  };
  const handleReservedTenantDetail = () => {
    const tenantId = selectedBed?.occupancies?.[1]?.tenantId;

    navigate(`/tenantdetails/b/${selectedBed.id}/${tenantId}`, {
      state: { tenantStatus: Config.TENANT_STATUS.RESERVED, tenantId: tenantId },
    });
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (apiData) {
      let filteredData = apiData;

      if (selectedFilter === "ALL") {
        filteredData = filteredData.filter((room) => {
          if (Array.isArray(room.beds) && room.beds.length > 0) {
            return true;
          } else {
            return false;
          }
        });
      } else if (selectedFilter === "VACANT") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.VACANT
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.VACANT
            ),
          }));
      } else if (selectedFilter === "OCCUPIED") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.OCCUPIED
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.OCCUPIED
            ),
          }));
      } else if (selectedFilter === "MOVING_OUT") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some(
                (bed) => bed.status === Config.BED_STATUS.MOVING_OUT
              );
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter(
              (bed) => bed.status === Config.BED_STATUS.MOVING_OUT
            ),
          }));
      } else if (selectedFilter === "PENDING_DUES") {
        filteredData = filteredData
          .filter((room) => {
            if (Array.isArray(room.beds)) {
              return room.beds.some((bed) => bed.isDuePending > 0);
            } else {
              return false;
            }
          })
          .map((room) => ({
            ...room,
            beds: room.beds.filter((bed) => bed.isDuePending > 0),
          }));
      }

      const tempData = filteredData?.map((item) => ({
        flat: getFloor(item),
        name: getName(item),
        occupancyStatus: getOccupancyStatus(item.beds, item),
        rent: getAmount(item.beds),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, selectedFilter, isFlat]);

  const getFloor = (item) => {
    return (
      <div className="flex text-sm textgray-600">
        <p>
          {isFlat
            ? `Flat ${item.flatName || item.name}`
            : `Floor ${item.floor}`}
        </p>
        {isFlat && item.flatName && (
          <FaEdit
            className="ml-2 mt-0.5 cursor-pointer text-blue-500"
            onClick={() => editFlat(item)}
          />
        )}
      </div>
    );
  };

  const getName = (item) => {
    const isDisabled = item.flatStatus === Config.FLAT_STATUS.INACTIVE;

    return (
      <div className="flex items-center text-sm text-gray-600">
        {item.roomNum ? (
          <>
            {item.roomNum}
            <FaEdit
              className={`ml-2 mb-1 cursor-pointer ${isDisabled
                ? "text-gray-400 cursor-not-allowed"
                : "text-blue-500"
                }`}
              title={isDisabled ? "First activate the flat" : "Edit Room"}
              onClick={() => {
                if (!isDisabled) {
                  editRoom(item);
                }
              }}
            />
          </>
        ) : (
          <BsDash className="w-7 h-7" />
        )}
      </div>
    );
  };

  const getAmount = (beds) => {
    const firstBed = beds?.[0];

    return firstBed ? (
      <Amount className="flex items-center text-sm text-gray-600">
        {"₹" + firstBed.rent}
      </Amount>
    ) : (
      <BsDash className="w-7 h-7" />
    );
  };

  // const getToolStatusText = (bed) => {
  //   const paymentStatus = bed.isDuePending > 0 ? "Dues" : "Paid";

  //   return (
  //     <span className="flex items-center gap-1">
  //       {paymentStatus} -
  //       <div className="text-orange-500 flex items-center">
  //         {/* <FaRupeeSign /> */}
  //         {'₹' + bed.isDuePending}
  //       </div>
  //     </span>
  //   );
  // };

  const getToolStatusText = (bed) => {
    if (bed.isDuePending > 0) {
      return (
        <span className="flex items-center gap-1 text-xs font-medium text-red-600">
          <span>Pending</span>
          <span className="text-red-700">
            ₹{bed.isDuePending.toLocaleString()}
          </span>
        </span>
      );
    }

    return (
      <span className="text-xs font-medium text-green-600">
        Paid
      </span>
    );
  };


  const BED_STATUS_NAMES = {
    [Config.ROOM_STATUS.INACTIVE]: "Inactive Room",
    [Config.BED_STATUS.VACANT]: "Vacant",
    [Config.BED_STATUS.VACANT_RESERVED]: "Vacant Reserved",
    [Config.BED_STATUS.OCCUPIED]: "Occupied",
    [Config.BED_STATUS.MOVING_OUT]: "Moving Out",
    [Config.BED_STATUS.RESERVED]: "Reserved",
  };
  const getOccupancyStatus = (beds = [], item) => {

    const validBeds = Array.isArray(beds) ? beds : [];

    return (
      <div className="flex flex-wrap items-center gap-2 max-w-md">
        {validBeds.map((bed) => {
          let bedColor = "";

          if (item.status === Config.ROOM_STATUS.INACTIVE) {
            bedColor = "text-gray-200";
          } else if (
            bed.status === Config.BED_STATUS.OCCUPIED &&
            item.isFlatFullyOccupied
          ) {
            bedColor = "text-yellow-400 cursor-pointer";
          } else if (
            bed.status === Config.BED_STATUS.OCCUPIED &&
            item.isFullyOccupied &&
            item.type !== Config.ROOM_TYPES.SINGLE_SHARING
          ) {
            bedColor = "text-violet-600 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.OCCUPIED) {
            bedColor = "text-green-400 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.VACANT) {
            bedColor = "text-gray-400 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.MOVING_OUT) {
            bedColor = "text-red-600 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.VACANT_RESERVED) {
            bedColor = "text-teal-400 cursor-pointer";
          } else if (bed.status === Config.BED_STATUS.RESERVED) {
            bedColor = "text-blue-500 cursor-pointer";
          } else {
            bedColor = "text-red-500 cursor-pointer";
          }

          let clickTimeout = null;
          let clickCount = 0;

          const handleClick = (e) => {
            e.stopPropagation();
            clickCount++;

            if (clickCount === 1) {
              clickTimeout = setTimeout(() => {
                if (item.status !== Config.ROOM_STATUS.INACTIVE) {
                  handleBedClick(bed, item);
                }
                clickCount = 0;
              }, 300);
            }
          };

          const handleDoubleClick = (e) => {
            e.stopPropagation();
            clearTimeout(clickTimeout);
            clickCount = 0;

            if (bed.status === Config.BED_STATUS.VACANT && item.status !== Config.ROOM_STATUS.INACTIVE) {
              deleteBed(bed);
            }
          };

          const tooltipContentOld = (
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-4">
                <div className="flex items-center">
                  {propStatus === 2 || propStatus === 4 ? (
                    <span className="text-red-500 font-semibold text-base flex">
                      <IoMdHelpCircleOutline className="w-6 h-6 mr-2" />
                      Please activate the property first from the properties page to add the tenant.
                    </span>
                  ) : (
                    <>
                      {" "}
                      <TbRectangleVerticalFilled
                        className={`w-6 h-6 ${bedColor} mr-2`}
                      />
                      <span className="text-sm font-medium text-gray-800">
                        {item.status === Config.ROOM_STATUS.INACTIVE ? (
                          <span className="text-red-500 font-medium text-base flex">
                            Inactive Room. Please activate the room first to
                            add tenant.
                          </span>
                        ) : (
                          BED_STATUS_NAMES[bed.status] || "Unknown Status"
                        )}
                      </span>
                      {bed.status === Config.BED_STATUS.VACANT && (
                        <span className="text-xs text-gray-500 ml-2">
                          (Double click to delete)
                        </span>
                      )}
                    </>
                  )}
                </div>
                {bed.isDuePending > 0 && (
                  <span className="text-sm font-semibold">
                    {getToolStatusText(bed)}
                  </span>
                )}
              </div>

              {/* Row 2: Tenant info */}
              {(bed.status === Config.BED_STATUS.OCCUPIED ||
                bed.status === Config.BED_STATUS.MOVING_OUT ||
                bed.status === Config.BED_STATUS.RESERVED) &&
                bed.occupancies?.length > 0 && (
                  // <div className="ml-8 mt-1 space-y-1 text-xs text-gray-600">
                  //   {bed.occupancies.map((occ, index) => (
                  //     <div key={occ.id || index} className="space-y-0.5">
                  //       <div className="font-medium text-gray-800">
                  //         {occ?.tenantName ? truncateText(occ?.tenantName, 20) : ''}
                  //         <span className="text-gray-500">
                  //           {occ?.status !== undefined &&
                  //             ' (' + (BED_STATUS_NAMES[occ.status] || 'Unknown') + ')'}
                  //         </span>
                  //       </div>

                  //       {occ?.tenantMobile && (
                  //         <div className="text-gray-500">
                  //           {'#' + occ.tenantMobile}
                  //         </div>
                  //       )}
                  //     </div>
                  //   ))}
                  // </div>
                  <div className="mt-2 space-y-2 border-t pt-2">
                    {bed.occupancies.map((occ, index) => (
                      <div
                        key={occ.id || index}
                        className="flex flex-col gap-0.5"
                      >
                        {/* Tenant name + status */}
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium text-gray-800">
                            {capitalizeFirstLetter(truncateText(occ?.tenantName || "—", 22))}
                          </span>

                          {occ?.status !== undefined && (
                            <span className="text-[11px] px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
                              {BED_STATUS_NAMES[occ.status] || "Unknown"}
                            </span>
                          )}
                        </div>

                        {/* Contact (secondary) */}
                        {occ?.tenantMobile && (
                          <span className="text-xs text-gray-500">
                            {occ.tenantMobile}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>

                )}
            </div>
          );

          /* ---------- HELPERS ---------- */

          const getInitials = (name = "") =>
            name
              .split(" ")
              .slice(0, 2)
              .map(n => n[0])
              .join("")
              .toUpperCase();

          const getGenderIcon = (gender) => {
            if (gender === 1) return "♂";
            if (gender === 2) return "♀";
            return null;
          };

          const getStatusLabel = (status) =>
            BED_STATUS_NAMES[status] || "Unknown";

          /* ---------- TOOLTIP CONTENT ---------- */

          const tooltipContent = (
            <div className="w-72 rounded-lg bg-white shadow-lg p-3">
              {/* HEADER */}
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  <TbRectangleVerticalFilled className={`w-5 h-5 ${bedColor}`} />
                  <span className="text-sm font-semibold text-gray-800">
                    {getStatusLabel(bed.status)}
                  </span>
                </div>

                {bed.isDuePending > 0 && (
                  <span className="text-sm font-semibold text-red-600">
                    Pending ₹{bed.isDuePending}
                  </span>
                )}
              </div>

              {/* WARNING */}
              {(propStatus === 2 || propStatus === 4) && (
                <div className="mt-2 flex gap-2 text-red-600 text-xs">
                  <IoMdHelpCircleOutline className="w-4 h-4 shrink-0 mt-0.5" />
                  <span>
                    Please activate the property first to add a tenant.
                  </span>
                </div>
              )}

              {/* TENANT LIST */}
              {(bed.status === Config.BED_STATUS.OCCUPIED ||
                bed.status === Config.BED_STATUS.MOVING_OUT ||
                bed.status === Config.BED_STATUS.RESERVED) &&
                bed.occupancies?.length > 0 && (
                  <>
                    <div className="my-2 border-t border-gray-200" />

                    <div className="space-y-2">
                      {bed.occupancies.map((occ, index) => (
                        <div
                          key={occ.id || index}
                          className="flex items-center gap-2 rounded-md px-2 py-2 hover:bg-gray-50 cursor-pointer"
                          onClick={() => goToTenantDetails(occ.tenantId)}
                        >
                          {/* AVATAR */}
                          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-semibold text-gray-700">
                            {getGenderIcon(occ.tenantGender) ||
                              getInitials(occ.tenantName)}
                          </div>

                          {/* INFO */}
                          <div className="flex flex-col">
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-medium text-gray-800">
                                {capitalizeFirstLetter(
                                  truncateText(occ?.tenantName || "—", 18)
                                )}
                              </span>

                              {occ?.status !== undefined && (
                                <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">
                                  {getStatusLabel(occ.status)}
                                </span>
                              )}
                            </div>

                            {occ?.tenantMobile && (
                              <span className="text-xs text-gray-500">
                                {occ.tenantMobile}
                              </span>
                            )}
                          </div>

                          {/* CTA */}
                          {/* <span className="ml-auto text-xs text-blue-600 font-medium">
                            View tenant
                          </span> */}
                        </div>
                      ))}
                    </div>
                  </>
                )}

              {/* VACANT BED CTA */}
              {bed.status === Config.BED_STATUS.VACANT && (
                <>
                  <div className="my-2 border-t border-gray-200" />

                  <div
                    className="px-2 py-2 rounded-md hover:bg-blue-50 cursor-pointer"
                    onClick={handleAddNewTenant}
                  >
                    <span className="text-sm font-medium text-blue-600">
                      + Click to add tenant
                    </span>
                  </div>

                  <div className="mt-1 text-xs text-gray-400">
                    Double click to delete bed
                  </div>
                </>
              )}
            </div>
          );



          return (
            <CustomTooltip
              key={`tooltip-${item.id}-${bed.id}`}
              content={tooltipContent}
              id={`tooltip-occupancyStatus-${item.id}-${bed.id}`}
            >
              <div
                key={`bed- ${bed.id}`}
                className="relative"
                onClick={handleClick}
                onDoubleClick={handleDoubleClick}
              >
                {bed.isDuePending > 0 && (
                  <FaRupeeSign className="absolute top-3 left-1/2 transform -translate-x-1/2 text-white w-4 h-4 cursor-pointer" />
                )}
                <TbRectangleVerticalFilled className={`${bedColor} w-10 h-10`} />
              </div>
            </CustomTooltip>
          );
        })}
        {beds.length > 0 &&
          <span className="text-xs text-gray-400 ml-2">
            {beds.length} beds
          </span>
        }
      </div>


    );
  };

  const ActionBtns = (item) => {
    const hasBeds = item.beds && item.beds.length > 0;
    const allBedsVacant = hasBeds && item.beds.every((bed) => bed.status === 1);
    const disableButton =
      (hasBeds && !allBedsVacant) ||
      item.status === Config.ROOM_STATUS.INACTIVE || selectedFilter === "VACANT";

    return (
      <div className="flex gap-3 items-center ">
        {item.roomNum ? (
          <button
            title={disableButton ? "Beds already occupied" : "Add Bed"}
            onClick={() => {
              if (!disableButton) {
                bed(item);
              }
            }}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium border rounded-lg ${disableButton
              ? "cursor-not-allowed  text-gray-400 border-gray-300"
              : "cursor-pointer text-gray-600 border-gray-500 hover:bg-gray-100 hover:text-gray-900"
              }`}

            disabled={disableButton}
          >
            <FaBed className="mr-1" />
            Add Bed
          </button>
        ) : (
          <button onClick={() => addRoomNumber(item)} className="flex items-center gap-2 px-4 py-2 text-sm font-medium cursor-pointer hover:bg-blue-500 border border-gray-500 hover:text-white rounded-lg text-gray-600">
            <MdOutlineMeetingRoom className="mr-1" />
            Add Room
          </button>
        )
        }
      </div >
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Flat/Floor",
          accessor: "flat",
        },
        {
          Header: "Room Name",
          accessor: "name",
        },
      ];
    }

    const bedStatusTooltipContent = (
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-green-400 w-6 h-6" />
          <span>Occupied</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-gray-400 w-6 h-6" />
          <span>Vacant</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-red-600 w-6 h-6" />
          <span>Moving Out</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-teal-400 w-6 h-6" />
          <span>Vacant Reserved</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-blue-500 w-6 h-6" />
          <span>Reserved</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-yellow-400 w-6 h-6" />
          <span>Fully Occupied (Flat)</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-violet-600 w-6 h-6" />
          <span>Fully Occupied (Room)</span>
        </div>
        <div className="flex items-center gap-2">
          <TbRectangleVerticalFilled className="text-gray-200 w-6 h-6" />
          <span>Inactive</span>
        </div>
        <div className="flex items-center gap-2">
          <FaCircle className="text-gray-400 w-6 h-6" />
          <span>Extra Bed</span>
        </div>
      </div>
    );

    return [
      {
        Header: "Flat/Floor",
        accessor: "flat",
      },
      {
        Header: "Room Name",
        accessor: "name",
      },
      {
        Header: () => (
          <div className="flex items-center">
            Bed Status
            <CustomTooltip
              content={bedStatusTooltipContent}
              id="bed-status-info"
              position="top"
            >
              <FaInfoCircle className="ml-2 text-gray-500 cursor-pointer" />
            </CustomTooltip>
          </div>
        ),
        accessor: "occupancyStatus",
      },
      {
        Header: "Rent/Bed",
        accessor: "rent",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  const goToTenantDetails = (bedId, tenantId) => {
    setIsModalOpen(false);
    //navigate(`/tenants/${tenantId}`);
    navigate(`/tenantdetails/b/${bedId}/${tenantId}`, {
      state: { tenantStatus: Config.TENANT_STATUS.RESERVED },
    });
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case Config.BED_STATUS.MOVING_OUT:
        return "Moving Out";
      case Config.BED_STATUS.RESERVED || Config.BED_STATUS.VACANT_RESERVED:
        return "Reserved";
      default:
        return "Active";
    }
  };


  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Bed Status:</strong>{" "}
                          {data[rowIndex].occupancyStatus}
                        </li>

                        <li className="flex gap-2">
                          <strong>Rent/Bed:</strong> {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>

      {isModalOpen && (

        <Model
          setOpenModel={setIsModalOpen}
          width="w-full max-w-sm"
          title="Bed Occupancy Details"
        >
          {selectedBed?.occupancies?.map((occ, index) => (
            <div key={occ.tenantId}>
              <button
                className="w-full text-left px-4 py-3 hover:bg-gray-100 flex justify-between items-center"
                onClick={() => goToTenantDetails(selectedBed.id, occ.tenantId)}
              >
                <div className="flex flex-col w-full">
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-900 font-medium">
                      {occ.tenantName || `Tenant ${index + 1}`}
                    </span>

                    <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">
                      {getStatusLabel(occ.status)}
                    </span>
                  </div>

                  <span className="text-sm text-gray-500">
                    {occ.mobileNumber}
                  </span>

                  <span className="text-xs text-gray-500">
                    Room {selectedBed.roomNum}
                  </span>
                </div>

                <span className="text-gray-400 text-lg ml-2">→</span>
              </button>

              {index !== selectedBed.occupancies.length - 1 && (
                <div className="border-t border-gray-200 mx-4" />
              )}
            </div>
          ))}

          {true && (
            <>
              <div className="border-t border-gray-300" />
              <button
                className="w-full text-left px-4 py-3 text-primary-color font-medium hover:bg-primary-color/50"
                onClick={handleAddNewTenant}
              >
                + Add New Tenant
              </button>
            </>
          )}
        </Model>




        // <Model
        //   setOpenModel={setIsModalOpen}
        //   width={"w-full max-w-sm"}
        //   title="Bed Move Out"
        // >
        //   <button
        //     className="w-full text-left text-gray-900 px-4 py-3 hover:bg-gray-100"
        //     onClick={handleEvictedTenantDetail}
        //   >
        //     Evicted tenant details
        //   </button>
        //   <div className="border-t border-gray-300"></div>
        //   {selectedBed.status === Config.BED_STATUS.MOVING_OUT && (
        //     <button
        //       className="w-full text-left text-gray-900 px-4 py-3 hover:bg-gray-100"
        //       onClick={handleAddNewTenant}
        //     >
        //       Add new tenant
        //     </button>
        //   )}
        //   {selectedBed.status === Config.BED_STATUS.RESERVED && (
        //     <button
        //       className="w-full text-left text-gray-900 px-4 py-3 hover:bg-gray-100"
        //       onClick={handleReservedTenantDetail}
        //     >
        //       Reserved tenant Detail
        //     </button>
        //   )}
        // </Model>
      )}

      {apiData?.length > 0 && (
        <PaginationWrapper className='pb-6'>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
//const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Thead = tw.thead`
  border-b bg-gray-50
`;

const Tbody = tw.tbody`${(props) =>
  props.hasdata === "true" ? "border-b" : ""}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50 `;
//const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Th = tw.th`
  text-left text-xs md:text-sm
  font-medium text-gray-500
  px-3 py-2
`;

const Td = tw.td`p-1 text-sm md:p-3 text-left`;
const Amount = tw.p`text-gray-700 text-sm font-medium flex`;
export default Table;